import { InjectionToken } from '@angular/core';
import { MtnaDialogButton } from '@mtna/core-angular';
import { MtnaResultTableOptions } from '@mtna/search-manager-angular';

/** The options available to inject for the data product dialog. */
export type RdsDataProductDialogOptions = Pick<MtnaResultTableOptions, 'columnWidths'> & { otherButtons?: MtnaDialogButton<unknown>[] };

/** Injection token to provide options to the data product dialog. */
export const RDS_DATA_PRODUCT_DIALOG_OPTIONS = new InjectionToken<RdsDataProductDialogOptions>('RDS_DATA_PRODUCT_DIALOG_OPTIONS');
